import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-confirmation-popup-warning',
    templateUrl: './confirmation-popup-warning.component.html',
    styleUrls: ['./confirmation-popup-warning.component.scss']
})
export class ConfirmationPopup_warningComponent implements OnInit {

    @Input() details: any;
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    constructor() { }

    ngOnInit(): void {
    }

    Cancel() {
        this.close.emit()
    }

    confirm() {
        this.close.emit(true);
    }

}
